export default __webpack_public_path__ + "static/media/streamline-icon-view-1@14x14.0235e002.svg";